/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/loginbackground.jpg";
import mastercardLogo from "assets/images/logos/mastercard.png";
import visaLogo from "assets/images/logos/visa.png";
import pciLogo from "assets/images/pcilogo.png";
import botimLogo from "assets/images/botim.png";
import version from "../../../../version";

import useApi from "../../../../components/Utils/api";
import toast from "utils/toast";
import { useNavigate } from "react-router-dom";

function Cover() {
  const api = useApi();
  const navigate = useNavigate();

  const formHandler = (form) => {
    form.preventDefault();
    const data = {
      username: form.target.username.value,
      user_type: "Merchant"
    }

    api.post("auth/admin/forgot-password", data)
    .then(response => {
      if (response.data.status === 200) {
        toast.success(response.data.message);
        if (response.data.message === 'Please change your password on first time' ||
            response.data.message === 'Otp has been sent to your registered email address. Please verify otp to login') {
          setTimeout(() => {
            navigate("/reset", { state: data });
          }, 2000);
        } else {
          setTimeout(() => {
            navigate("/login", { state: data });
          }, 2000);
        }
      }
    })
    .catch(error => {
      if (error.response && error.response.data.message) {
        toast.error(error.response.data.message);
      }
    });
  }

  return (
    <BasicLayout image={bgImage} showBackground hideFooter>
      <MDBox display="flex" alignItems="center" justifyContent="center" mb={4}>
        <MDBox component="img" src="/login_page_logo.png" alt="Logo" sx={{ height: "56px" }} />
      </MDBox>
      <Card sx={{ minHeight: "370px", width: "calc(100% + 20px)", display: "flex", flexDirection: "column" }}>
        <MDBox pt={4} pb={1} px={3} textAlign="left">
          <MDTypography variant="h5" fontWeight="bold" color="dark" sx={{ letterSpacing: "0.5px" }}>
            Forgot Password
          </MDTypography>
          <MDTypography display="block" variant="button" color="text" fontWeight="regular" mt={1}>
            You will receive an email on your registered email address.
          </MDTypography>
        </MDBox>
        <MDBox
          pt={1}
          pb={3}
          px={3}
          sx={{ flex: 1, display: "flex", flexDirection: "column" }}
        >
          <MDBox
            component="form"
            role="form"
            onSubmit={(form) => formHandler(form)}
            sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}
          >
            <MDBox mb={4}>
              <MDInput type="text" label="Username" name="username" fullWidth required />
            </MDBox>
            <MDBox mb={1}>
              <MDButton type="submit" variant="gradient" color="info" fullWidth>
                reset
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
      <MDBox display="flex" alignItems="center" justifyContent="center" gap={3} mt={3}>
        <MDBox component="img" src={mastercardLogo} alt="Mastercard" sx={{ height: "28px" }} />
        <MDBox component="img" src={visaLogo} alt="Visa" sx={{ height: "28px" }} />
        <MDBox component="img" src={pciLogo} alt="PCI DSS Compliant" sx={{ height: "28px" }} />
        <MDBox component="img" src={botimLogo} alt="Botim" sx={{ height: "28px" }} />
      </MDBox>
      <MDBox display="flex" alignItems="center" justifyContent="center" gap={1} mt={1.5} sx={{ whiteSpace: "nowrap" }}>
        <MDTypography variant="caption" color="text" sx={{ fontSize: "0.65rem" }}>
          &copy; {new Date().getFullYear()} YouCloud Technologies. All Rights Reserved.
        </MDTypography>
        <MDTypography variant="caption" color="text" sx={{ fontSize: "0.65rem" }}>
          Version {version}
        </MDTypography>
      </MDBox>
    </BasicLayout>
  );
}

export default Cover;
